// extracted by mini-css-extract-plugin
export var container = "QuestionHeading-module--container--1c9e2";
export var label = "QuestionHeading-module--label--2c2c6";
export var question = "QuestionHeading-module--question--aa838";